export default "__VITE_ASSET__D492XmUs__"